<template>
	<basic-container :block="payType === 'qr'">
		<div v-if="payType === 'qr'" class="u-flex-col u-col-center u-font-weight-bold u-font-sm" style="margin-top: 30px">
			使用手机扫描二维码进行支付操作
			<!--//二维码支付-->
			<qrcode :options="options" :value="payUrl" class="u-m-t-20" />
		</div>
		<div v-else>
			<el-row :gutter="20">
				<el-col :span="20">
					<el-input v-model="payUrl" :disabled="true"></el-input>
				</el-col>
				<el-col :span="4">
					<el-button icon="el-icon-document-copy" type="primary" @click="handleCopy2Clipboard(payUrl)">
						复制支付链接
					</el-button>
				</el-col>
			</el-row>
			<el-row v-loading="loading">
				<el-col :span="24">
					<iframe id="payWnd" :src="payUrl" class="payContainer" frameborder="0" scrolling="auto"></iframe>
				</el-col>
			</el-row>
		</div>
	</basic-container>
</template>

<script>
import {getStore} from '@/util/store'
import {getPayStatus} from '@/api/insurance/policy'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {isBxMeidiGuangfu} from '@/config/env'

export default {
	data() {
		return {
			payUrl: '',
			orderId: '',
			resultTimer: null,
			payOrderId: '',
			loading: true,
			isPayStatusLoading: false,
			payType: '',
			options: {
				height: 400,
				width: 400,
			},
			requestCount: 0,
			maxRequestCount: 15,
		}
	},
	components: {
		qrcode: VueQrcode,
	},
	created() {
		this.payOrderId = this.$route.params.id
		if (this.validatenull(this.payOrderId)) {
			this.$message.error('数据有误!')
			this.loading = false
			return
		}
		let {payUrl, orderId, payType = ''} = getStore({name: this.payOrderId})
		this.payUrl = payUrl
		this.orderId = orderId
		this.payType = payType
		if (isBxMeidiGuangfu) {
			//开启定时查询
			this.getPayResult()
		}
	},
	mounted() {
		if (this.payType !== 'qr') {
			const iframe = document.getElementById('payWnd')
			//处理兼容
			if (iframe.attachEvent) {
				iframe.attachEvent('onload', () => {
					this.loading = false
				})
			} else {
				iframe.onload = () => {
					this.loading = false
				}
			}
		}
	},
	methods: {
		handleCopy2Clipboard(payUrl) {
			this.$Clipboard({
				text: payUrl,
			})
				.then(() => {
					this.$message.success('复制成功')
				})
				.catch(() => {
					this.$message.success('复制失败')
				})
		},
		getPayResult() {
			//设置定时器
			if (!this.orderId) {
				//从订单页面进来的
				return
			}
			this.resultTimer = setInterval(() => {
				if (this.requestCount >= this.maxRequestCount) {
					if (this.resultTimer) {
						clearInterval(this.resultTimer)
						this.resultTimer = null
					}
					return
				}
				if (this.isPayStatusLoading) {
					return
				}
				this.isPayStatusLoading = true
				this.requestCount++
				getPayStatus(this.payOrderId)
					.then((response) => {
						if (!this.validatenull(this.resultTimer)) {
							clearInterval(this.resultTimer)
							this.resultTimer = null
						}
						//提示，投保成功，请关闭当前页面
						this.$alert('当前保单已支付成功，请返回保单列表页查看数据！', '提示', {
							confirmButtonText: '我知道了',
						}).then(() => {
							window.close()
						})
					})
					.catch(() => {})
					.finally(() => {
						this.isPayStatusLoading = false
					})
			}, 20000)
		},
	},
	beforeDestroy() {
		//关闭
		if (this.resultTimer) {
			clearInterval(this.resultTimer)
			this.resultTimer = null
		}
	},
}
</script>

<style lang="scss" scoped>
.payContainer {
	position: relative;
	width: 100%;
	min-height: 720px;
	padding-bottom: 0px;
}
</style>
